module.exports = __webpack_public_path__ + "img/icon-documents.fc52f5c5.svg";